
import { Vue } from "vue-property-decorator";
import { parseTime } from "@/utils";

import api from "@/api/killrecord.ts";

export default class extends Vue {
  calendarShow = false;
  checkType = 0;
  checkTypes = [
    { text: "全部", value: 0 },
    { text: "我的", value: 1 },
  ];
  refreshing = false;
  loading = false;
  finished = false;
  list: any[] = [];
  date: Date | string = "";
  page = {
    pageSize: 10,
    pageNum: 1,
  };
  fChangeSearch() {
    this.refreshing = true;
    this.onRefresh();
  }
  currentDate() {
    return parseTime(this.date, "{m}月{d}日");
  }
  fConfirmDate(d: Date) {
    this.date = d;
    this.fChangeSearch();
    this.calendarShow = false;
  }
  onLoad() {
    setTimeout(() => {
      if (this.refreshing) {
        this.page.pageNum = 1;
        this.list = [];
        this.refreshing = false;
      }
      const reqjson = {
        projectId: this.$store.state.project.projectinfo.projectId,
        createDate: this.date ? parseTime(this.date, "{y}-{m}-{d}") : null,
        ...this.page,
      };
      let runfun = null;
      if (this.checkType === 0) {
        runfun = api.projectDisinfectRecordpage(reqjson);
      } else {
        runfun = api.projectDisinfectRecordgetOwnList(reqjson);
      }
      runfun.then((res: any) => {
        this.list = [...this.list, ...res.data.records];
        this.loading = false;
        this.page.pageNum++;
        if (this.list.length >= res.data.total) {
          this.finished = true;
        }
      });
    }, 500);
  }
  onRefresh() {
    // 清空列表数据
    this.finished = false;
    // 重新加载数据
    // 将 loading 设置为 true，表示处于加载状态
    this.loading = true;
    this.onLoad();
  }
  fGoAdd() {
    this.$router.push("/app/disinfectadd");
  }
  fSetTime() {
    this.date = "";
    this.calendarShow = false;
    this.fChangeSearch();
  }
}
